import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  linkedSignal,
  output,
  viewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IdValueType } from '@models/common';
import { SignatureComponent } from '@module-definition/signature/signature.component';
import { TranslateModule } from '@ngx-translate/core';
import { UserStore } from '@signal-store/index';
import { NotificationFormValue, TransitionFormData, TransitionFormValue } from '../common';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { NotificationFormComponent } from '../notification-form/notification-form.component';

/* This component takes the data from the store. Take into consideration to refactor transition dialog to also use this component.
For this, we need to think of a sollution to save data in dmStore.
Maybe add entityInstanceIds prop and save the transition data inside documents[0]?*/

@Component({
  selector: 'cipo-transition-form',
  imports: [TranslateModule, NotificationFormComponent, SignatureComponent, DynamicFormComponent],
  templateUrl: './transition-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransitionFormComponent {
  private userStore = inject(UserStore);
  dynamicFormComponent = viewChild<DynamicFormComponent>('dynamicForm');

  data = input.required<TransitionFormData>();
  form = input.required<FormGroup>();
  compactMode = input(false);
  transitionFormPrepared = output<TransitionFormValue>();

  notificationFormValue = linkedSignal<NotificationFormValue>(() => {
    const { notificationData } = this.data();
    if (!notificationData) {
      return null;
    }
    const { excludeRoles, includeAttachments, notify } = notificationData;
    return {
      excludeRoles,
      includeAttachments,
      notify,
    };
  });
  userHasSignature = linkedSignal(() => !!this.userStore.userData()?.signature);
  notificationData = computed(() => {
    const { notificationData, contractId, moduleId } = this.data();
    if (!notificationData?.notifyOptions?.length || notificationData?.hideRolesNotify) {
      return null;
    }
    return {
      contractId,
      moduleId,
      ...notificationData,
    };
  });

  onNotificationValueChanged(value: NotificationFormValue) {
    this.notificationFormValue.set(value);
  }

  submit() {
    this.dynamicFormComponent().submit();
  }

  handleSubmit(values: IdValueType<any, number>[]) {
    this.transitionFormPrepared.emit({ values, notificationData: this.notificationFormValue() });
  }
}
